import React from 'react';
import { Typography, Space, Grid } from 'antd';
import PropTypes from 'prop-types';

const { Title } = Typography;
const { useBreakpoint } = Grid;

const PageHeader = ({ title, subtitle, extra }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  return (
    <div
      style={{
        marginBottom: 24,
        padding: isMobile ? '12px 0' : '16px 0',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? 16 : 0,
        }}
      >
        <Space direction="vertical" size={4} style={{ width: isMobile ? '100%' : 'auto' }}>
          <Title 
            level={2} 
            style={{ 
              margin: 0,
              fontSize: isMobile ? '20px' : '24px',
              lineHeight: isMobile ? '28px' : '32px',
            }}
          >
            {title}
          </Title>
          {subtitle && (
            <Typography.Text 
              type="secondary"
              style={{
                fontSize: isMobile ? '14px' : '16px',
              }}
            >
              {subtitle}
            </Typography.Text>
          )}
        </Space>
        {extra && (
          <div style={{ 
            width: isMobile ? '100%' : 'auto',
          }}>
            {extra}
          </div>
        )}
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  extra: PropTypes.node,
};

export default PageHeader;
